import React, { useState } from 'react';
import TextInput from '../textInput/TextInput';
import styles from './NominateOrganisation.module.scss';
import { useDispatch } from 'react-redux';
import { nominateOrganisation } from '../../../redux/actions';
import Warning from '../warning/Warning';
import Button from '../button/Button';

const NominateOrganisation = props => {
  const dispatch = useDispatch();
  const [nominatedOrganisations, setNominatedOrganisations] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const onClickSubmitOrganisations = () => {
    if (nominatedOrganisations) {
      const request = {
        applicationNumber: props.applicationNumber || null,
        comments: nominatedOrganisations || null,
      };
      dispatch(nominateOrganisation(request));
      setShowConfirmation(true);
      setNominatedOrganisations('');
    }
  };

  return (
    <section>
      <div className={styles.container}>
        <div className={`container ${styles.container}`}>
          <div className={`content ${styles.content}`}>
            <h3>Nominate an organisation</h3>
            <p>
              If you know of an organisation that could benefit from being included, please enter
              its name.{' '}
            </p>
            <p>
              Your suggestion is anonymous: no identifying details are matched or saved in any way.
            </p>
            <div className={styles.innerContainer}>
              <TextInput
                name="nominatedOrganisations"
                value={nominatedOrganisations || ''}
                onInput={e => {
                  setNominatedOrganisations(e);
                  setShowConfirmation(false);
                }}
              />
              <Button onClick={onClickSubmitOrganisations}>Submit</Button>
            </div>
            {showConfirmation ? (
              <Warning
                id={'nominationSuccess'}
                type={'success'}
                description={`Success - Thank you for your submission`}
              />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NominateOrganisation;
